export default __webpack_public_path__ + "static/media/KOD0045-min.32d94167.webp";